"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('cube', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M24.0002 4L32.6605 9L41.3207 14V24V34L32.6605 39L24.0002 44L15.3399 39L6.67969 34V24V14L15.3399 9L24.0002 4Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M41.3207 14L32.6605 19M41.3207 14V24M41.3207 14L32.6605 9M24.0002 44L32.6605 39M24.0002 44L15.3399 39M24.0002 44V34M6.67969 14L15.3399 9M6.67969 14L15.3399 19M6.67969 14V24M24.0002 24L32.6605 19M24.0002 24L15.3399 19M24.0002 24V34M32.6605 19L15.3399 9M32.6605 19V39M15.3399 9L24.0002 4L32.6605 9M32.6605 39L41.3207 34V24M15.3399 39L6.67969 34V24M15.3399 39V19M15.3399 19L32.6605 9M6.67969 24L24.0002 34M24.0002 34L41.3207 24",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;